import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timi-workspace-header" }
const _hoisted_2 = { class: "branding" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "timi.tools", -1)
const _hoisted_5 = { class: "workstation" }
const _hoisted_6 = { class: "headerinfo" }
const _hoisted_7 = { class: "headline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: "svgicon",
        innerHTML: _ctx.store.getters.svgIcons.timi
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.workstation.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(_ctx.displayCurrentTime), 1)
      ]),
      _createVNode(_component_IconButton, {
        icon: _ctx.icons.settings,
        onClick: _ctx.onSettingsClick
      }, null, 8, ["icon", "onClick"])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}